import React from 'react';

function ChevronLeft({color = 'white'}) {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M10.5836 13.1672L5.59998 8.1836L10.5836 3.2" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default ChevronLeft;